<template>
  <div class="sports-menu">
    <nav v-if="tabletAndAbove">
      <site-navigation :navigation-section="'BO_POPULAR'" class="popular expand navigation"></site-navigation>
      <main-navigation class=" navigation"></main-navigation>
      <!--site-navigation :navigation-section="'BO_TOP_SPORTS'" class="top-sports"></site-navigation-->

      <div class="wrapper sports-az navigation">
        <h3> {{ $t('Sports.AllSports') }}</h3>
        <bo-navigation p-idfwbonavigation="top" :order-by-name="true" :preselect-first-node="false"></bo-navigation>
      </div>
    </nav>
    <nav v-else>
      <template>
        <ul> 
          <li class="live_link"><span @click="goToLive()"><span class="pd-icon pd-icon-live"></span>EVENTS</span></li>
        </ul>
        <div class="wrapper sports-az navigation"> 
          <bo-navigation p-idfwbonavigation="top" :order-by-name="true" :preselect-first-node="false"></bo-navigation>
        </div>
      </template>
    </nav>
  </div>

</template>
<script>
  import store from '@/store'
  import SiteNavigation from '@/components/common/SiteNavigation'
  import BoNavigation from '@/components/sports/bettingoffer/BoNavigation'
  import MainNavigation from '@/components/common/MainNavigation'
  import Screen from '@/components/mixins/Screen'
  import config from '@/config'
  import Icon from '@/components/common/Icon'

  export default {
    name: 'sports-menu',

    mixins: [
      Screen
    ],
    components: {
      SiteNavigation,
      MainNavigation,
      BoNavigation,
      Icon
    },
    data () {
      return {
        menuOpened: false
      }
    },
    methods: {
      goToLive () {
        this.$router.push({name: 'sports-live', params: { }})
        store.dispatch('overlayState/deactivateBetslip')
        store.dispatch('overlayState/deactivateSportsMenu')
        store.dispatch('overlayState/deactivateHamburgerMenu')
        store.dispatch('overlayState/deactivateMyAccountDialog')
      }
    },
    computed: {
      externalUrls () {
        return config.externalUrls
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import "~@/css/config"

a
  color #06283b

h5
  vertical-align: middle
.live_link
  color #1f375b
  text-transform uppercase
  font-size 14px
  border-bottom 2px solid #e9eef5
  padding 10px 0
  .pd-icon
    margin-right 5px
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/SportsMenu.vue